import React, {useCallback} from "react";
import { Link } from "react-router-dom";
import { ArrowLeftIcon } from "@heroicons/react/solid";
import useBackNavigation from "../../../hooks/useBackNavigation";

const ListFooter = ({ backLink, backLabel }) => {
  const handleBackNavigation = useBackNavigation(backLink);

  const handleClick = useCallback((event) => {
    if (
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.altKey ||
      event.ctrlKey ||
      event.shiftKey
    ) {
      return;
    }

    event.preventDefault();
    handleBackNavigation();
  }, [handleBackNavigation]);

  if (!backLink) {
    return null;
  }

  return (
    <div className=" py-3 bg-solitude-100 text-right  flex">
      <Link
        to={backLink}
        onClick={handleClick}
        className="text-sm underline inline-flex  items-center"
      >
        <ArrowLeftIcon className="h-4 w-4 mr-2" aria-hidden="true" />{" "}
        {backLabel}
      </Link>
    </div>
  );
};

export default ListFooter;
